import styles from 'sections/danceShow/showsAbout/showsAbout.module.css';
import generalStyles from 'index.module.css';

import React, { useState } from 'react';
import { Element } from 'react-scroll';
import { Trans, useTranslation } from 'react-i18next';
import { useGetShowsAboutInfo } from 'sections/danceShow/showsAbout/showsAboutInfo.hook';
import FullscreenPlayer from 'components/fullscreenPlayer/FullscreenPlayer';
import { Popup } from 'components/popup/Popup';
import { ContactFormBookEventLazy } from 'components/contactFormBookEvent/ContactFormBookEventLazy';

export const ShowsAbout = () => {
    const { t } = useTranslation();
    const showsInfo = useGetShowsAboutInfo();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isImgLoaded, setIsImgLoaded] = useState(false);
    const handleImageLoad = () => {
        setIsImgLoaded(true);
    };
    const openClosePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <section
            id="section-shows-about"
            className={`${generalStyles.heightAuto} ${styles.showsAboutSection}`}
        >
            <Element name="showsAbout">
                <ul className={styles.showsAbout}>
                    {showsInfo.map(({ title, info, url, thumbnailSrc, id }) => {
                        return (
                            <li key={title} className={styles.show}>
                                <div className={styles.show__video}>
                                    <FullscreenPlayer
                                        playerId={id}
                                        videoUrl={url}
                                        imageUrl={thumbnailSrc}
                                        isImgLoaded={isImgLoaded}
                                        handleImageLoad={handleImageLoad}
                                        title={title}
                                    />
                                </div>
                                <div className={styles.show__info}>
                                    <h2>{title}</h2>
                                    <p style={{ whiteSpace: 'pre-line' }}>
                                        <Trans
                                            i18nKey={info}
                                            components={{ b: <b /> }}
                                        />
                                    </p>
                                    <button
                                        className={styles.show__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </Element>

            <Popup isOpen={isPopupOpen} onClose={openClosePopup}>
                <ContactFormBookEventLazy onClose={openClosePopup} />
            </Popup>
        </section>
    );
};
